import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { HttpClientBase } from "./http-client-base.service";

interface ApiResponse<T> {
  item: T[];
}

@Injectable({ providedIn: "root" })
export class UsuariosService extends HttpClientBase {
  private endpoint = "usuarios";
  private endpoint_register_user = "auth/register";

  constructor(http: HttpClient) {
    super(http, "usuarios");
  }

  get headers() {
    return {
      headers: {},
    };
  }

  getUsuarios(page, limit, search = null, pagination = "true") {
    return this.get<any[]>({
      endpoint: `?page=${page}&limit=${limit}&search=${search}&pagination=${pagination}`,
    });
  }

  getGrupoUsuarios(params) {
    return this.get<any[]>({ endpoint: `grupos/descendientes`, params });
  }

  getUsuario(id: string) {
    return this.get<any>({ endpoint: `/${id}` });
  }

  createUsuario(data: any) {
    return this.post<any>(data);
  }

  updateUsuario(id: number | string, data: any) {
    return this.put<any>(data, `${id}`);
  }

  subidaImagen(id: number | string, data: any) {
    return this.put<any>(data, `${id}/imagenes/firmas`);
  }

  verImagenFirma(url: string, params) {
    return this.get<any[]>({ endpoint: `files/${url}`, params });
  }

  resetPassword(userNameOrEmail) {
    return this.post<any>({ search: userNameOrEmail }, "reset-password");
  }

  updatePassword(id: number | string, data: any) {
    return this.patch<any>(data, `${id}/password`);
  }

  deleteUsuario(id: number) {
    return this.delete<any>(`${id}`);
  }

  userGroups(params: any) {
    return this.get<any>({ endpoint: "grupos/descendientes", params });
  }

  guardarGrupo(body: any) {
    return this.post<any>(body, `grupos/descendientes`);
  }

  asignUserGroup(data: any) {
    return this.post<any>(
      data,
      `grupos/asignar`,
      undefined,
      true, // 👈 activa el loader
    );
  }

  getUserGroupsByCertificate(params: any) {
    return this.get<any>({ endpoint: "grupos/asignaciones", params });
  }

  deleteGrupo(id: number) {
    return this.delete<any>(
      `grupos/${id}`,
      undefined,
      undefined,
      true, // 👈 loader
    );
  }

  firmarConImagen(id: number | string, data: any) {
    return this.put<any>(data, `${id}`);
  }
}
